module.exports = __webpack_public_path__ + "img/parents-2@2x.5389ad68.jpg";